import React, { useState, useEffect } from "react";
import "./HealthOneFaq.scss";
import { useCollection } from "../../../../firebase-files/hooks/useCollection"; 
import AddFaqs from "../../../../default-hooks/AddFaqs";

const HealthOneFaq = () => {
  const { documents: allFaqs, error } = useCollection("faqs");

  const [isMobile, setIsMobile] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 480);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (error) {
    return <div>Error loading FAQs: {error}</div>;
  }

  if (!allFaqs) {
    return <div>Loading FAQs...</div>;
  }

  // ✅ Filter active status
  const faqs = allFaqs.filter((faq) => faq.status === "active");

  // ✅ Limit to first 8
  const limitedFaqs = faqs.slice(0, 8);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  
  const displayedFaqs = () => {
    if (!isMobile) return limitedFaqs;
    if (showAll) return limitedFaqs;
    return limitedFaqs.slice(0, 2);
  };
  
  const firstColumnFaqs = limitedFaqs.slice(0, 4);
  const secondColumnFaqs = limitedFaqs.slice(4, 8);

  return (
    <section className="health-one-faq-section">
      <p className="health-one-common-parent-sub-heading">QUESTIONS & ANSWER</p>
      <h2 className="health-one-common-black-parent-heading">
        Learn more about our platform <br /> by user questions
      </h2>

      <div className="faq-columns">
        {!isMobile ? (
          <>
            <div className="faq-column">
              {firstColumnFaqs.map((faq, index) => (
                <div
                  className={`faq-box ${activeIndex === index ? "active" : ""}`}
                  key={index}
                  onClick={() => toggleFAQ(index)}
                >
                  <div className="question">{faq.question}</div>
                  {activeIndex === index && (
                    <div className="answer">{faq.answer}</div>
                  )}
                  <div className="plus-icon">{activeIndex === index ? "−" : "+"}</div>
                </div>
              ))}
            </div>
            <div className="faq-column">
              {secondColumnFaqs.map((faq, index) => {
                const globalIndex = index + 4;
                return (
                  <div
                    className={`faq-box ${activeIndex === globalIndex ? "active" : ""}`}
                    key={globalIndex}
                    onClick={() => toggleFAQ(globalIndex)}
                  >
                    <div className="question">{faq.question}</div>
                    {activeIndex === globalIndex && (
                      <div className="answer">{faq.answer}</div>
                    )}
                    <div className="plus-icon">{activeIndex === globalIndex ? "−" : "+"}</div>
                  </div>
                );
              })}
            </div>
          </>
        ) : (
          <div className="faq-column">
            {displayedFaqs().map((faq, index) => (
              <div
                className={`faq-box ${activeIndex === index ? "active" : ""}`}
                key={index}
                onClick={() => toggleFAQ(index)}
              >
                <div className="question">{faq.question}</div>
                {activeIndex === index && (
                  <div className="answer">{faq.answer}</div>
                )}
                <div className="plus-icon">{activeIndex === index ? "−" : "+"}</div>
              </div>
            ))}
          </div>
        )}
      </div>

      {isMobile && !showAll && (
        <button className="show-more-btn" onClick={() => setShowAll(true)}>Show More</button>
      )}
      {isMobile && showAll && (
        <button className="show-less-btn" onClick={() => setShowAll(false)}>Show Less</button>
      )}
      <AddFaqs/>
    </section>
    
  );
};

export default HealthOneFaq;
